import { render, staticRenderFns } from "./Creative.vue?vue&type=template&id=936fac04&scoped=true&"
import script from "./Creative.vue?vue&type=script&lang=ts&"
export * from "./Creative.vue?vue&type=script&lang=ts&"
import style0 from "./Creative.vue?vue&type=style&index=0&id=936fac04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936fac04",
  null
  
)

export default component.exports